<template>
  <input
    :type="type"
    :value="modelValue"
    v-bind="$attrs"
    class="input"
    :class="getInputClasses"
    @input="onInput($event)"
    @keypress.enter="onEnter"
  >
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    modelValue: {
      type: [Number, String],
      default: ''
    },
    type: {
      type: String,
      default: 'text',
      validator: value => ['text', 'password', 'time', 'number', 'date'].includes(value)
    },
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    'update:modelValue': null,
    enter: null
  },
  computed: {
    getInputClasses () {
      return {
        input_search: this.isSearch
      }
    }
  },
  methods: {
    /* Срабатывает по событию input */
    onInput (event) {
      this.$emit('update:modelValue', event.target.value)
    },
    onEnter (event) {
      this.$emit('enter', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  display: block;
  padding: 0 16px;
  width: 100%;
  height: 42px;
  background: #242428;
  border-radius: 10px;
  border: none;
  appearance: none;
  outline: none;
  font-weight: 400;
  font-size: 18px;
  color: #A1A1A8;
  line-height: 1.5;

  &_search {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M7.33329 14.0001C8.81244 13.9998 10.249 13.5046 11.4141 12.5934L15.0775 16.2567L16.2558 15.0784L12.5925 11.4151C13.5041 10.2498 13.9996 8.81295 14 7.33341C14 3.65758 11.0091 0.666748 7.33329 0.666748C3.65746 0.666748 0.666626 3.65758 0.666626 7.33341C0.666626 11.0092 3.65746 14.0001 7.33329 14.0001ZM7.33329 2.33341C10.0908 2.33341 12.3333 4.57591 12.3333 7.33341C12.3333 10.0909 10.0908 12.3334 7.33329 12.3334C4.57579 12.3334 2.33329 10.0909 2.33329 7.33341C2.33329 4.57591 4.57579 2.33341 7.33329 2.33341Z' fill='%23A1A1A8'/%3e%3c/svg%3e ");
    background-repeat: no-repeat;
    background-position-x: 16px;
    background-position-y: center;
    background-size: 18px;
    padding-left: 40px;
  }

  &[type="time"] {
    padding: 0 8px;

    &::-webkit-calendar-picker-indicator {
      opacity: 0;
    }
  }

  &[type="date"] {
    &::-webkit-calendar-picker-indicator {
      color: transparent;
      opacity: 1;
      background-size: contain;
      background-image: url("data:image/svg+xml,%3Csvg width='11' height='14' viewBox='0 0 11 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.63587 7.875H2.65399C2.49198 7.875 2.35943 7.72734 2.35943 7.54688V6.45312C2.35943 6.27266 2.49198 6.125 2.65399 6.125H3.63587C3.79788 6.125 3.93043 6.27266 3.93043 6.45312V7.54688C3.93043 7.72734 3.79788 7.875 3.63587 7.875ZM6.28693 7.54688V6.45312C6.28693 6.27266 6.15438 6.125 5.99237 6.125H5.0105C4.84849 6.125 4.71593 6.27266 4.71593 6.45312V7.54688C4.71593 7.72734 4.84849 7.875 5.0105 7.875H5.99237C6.15438 7.875 6.28693 7.72734 6.28693 7.54688ZM8.64344 7.54688V6.45312C8.64344 6.27266 8.51088 6.125 8.34887 6.125H7.367C7.20499 6.125 7.07243 6.27266 7.07243 6.45312V7.54688C7.07243 7.72734 7.20499 7.875 7.367 7.875H8.34887C8.51088 7.875 8.64344 7.72734 8.64344 7.54688ZM6.28693 10.1719V9.07812C6.28693 8.89766 6.15438 8.75 5.99237 8.75H5.0105C4.84849 8.75 4.71593 8.89766 4.71593 9.07812V10.1719C4.71593 10.3523 4.84849 10.5 5.0105 10.5H5.99237C6.15438 10.5 6.28693 10.3523 6.28693 10.1719ZM3.93043 10.1719V9.07812C3.93043 8.89766 3.79788 8.75 3.63587 8.75H2.65399C2.49198 8.75 2.35943 8.89766 2.35943 9.07812V10.1719C2.35943 10.3523 2.49198 10.5 2.65399 10.5H3.63587C3.79788 10.5 3.93043 10.3523 3.93043 10.1719ZM8.64344 10.1719V9.07812C8.64344 8.89766 8.51088 8.75 8.34887 8.75H7.367C7.20499 8.75 7.07243 8.89766 7.07243 9.07812V10.1719C7.07243 10.3523 7.20499 10.5 7.367 10.5H8.34887C8.51088 10.5 8.64344 10.3523 8.64344 10.1719ZM10.9999 3.0625V12.6875C10.9999 13.4121 10.4722 14 9.82169 14H1.18118C0.530688 14 0.00292969 13.4121 0.00292969 12.6875V3.0625C0.00292969 2.33789 0.530688 1.75 1.18118 1.75H2.35943V0.328125C2.35943 0.147656 2.49198 0 2.65399 0H3.63587C3.79788 0 3.93043 0.147656 3.93043 0.328125V1.75H7.07243V0.328125C7.07243 0.147656 7.20499 0 7.367 0H8.34887C8.51088 0 8.64344 0.147656 8.64344 0.328125V1.75H9.82169C10.4722 1.75 10.9999 2.33789 10.9999 3.0625ZM9.82169 12.5234V4.375H1.18118V12.5234C1.18118 12.6137 1.24746 12.6875 1.32846 12.6875H9.67441C9.75541 12.6875 9.82169 12.6137 9.82169 12.5234Z' fill='%2355555E'/%3E%3C/svg%3E%0A");
    }
  }
}
</style>
